import { c as _c } from "react/compiler-runtime";
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectChangesSettingsControllerRemoveAutomaticPrimeContractMutationResponse, ProjectChangesSettingsControllerRemoveAutomaticPrimeContractPathParams, ProjectChangesSettingsControllerRemoveAutomaticPrimeContract401, ProjectChangesSettingsControllerRemoveAutomaticPrimeContract403, ProjectChangesSettingsControllerRemoveAutomaticPrimeContract404 } from "../../models/changeOrdersController/ProjectChangesSettingsControllerRemoveAutomaticPrimeContract";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { projectChangesSettingsControllerRemoveAutomaticPrimeContract } from "../../clients/change-ordersService/projectChangesSettingsControllerRemoveAutomaticPrimeContract";
import { mutationOptions, useMutation } from "@tanstack/react-query";
export const projectChangesSettingsControllerRemoveAutomaticPrimeContractMutationKey = () => [{
  url: '/api/v1/project-changes-settings/:projectId/automatic-prime-contract'
}] as const;
export type ProjectChangesSettingsControllerRemoveAutomaticPrimeContractMutationKey = ReturnType<typeof projectChangesSettingsControllerRemoveAutomaticPrimeContractMutationKey>;
export function projectChangesSettingsControllerRemoveAutomaticPrimeContractMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const mutationKey = projectChangesSettingsControllerRemoveAutomaticPrimeContractMutationKey();
  return mutationOptions<ProjectChangesSettingsControllerRemoveAutomaticPrimeContractMutationResponse, ResponseErrorConfig<ProjectChangesSettingsControllerRemoveAutomaticPrimeContract401 | ProjectChangesSettingsControllerRemoveAutomaticPrimeContract403 | ProjectChangesSettingsControllerRemoveAutomaticPrimeContract404>, {
    projectId: ProjectChangesSettingsControllerRemoveAutomaticPrimeContractPathParams["projectId"];
  }, TContext>({
    mutationKey,
    mutationFn: async ({
      projectId
    }) => {
      return projectChangesSettingsControllerRemoveAutomaticPrimeContract(projectId, config);
    }
  });
}

/**
 * @summary Remove the automatically selected prime contract
 * {@link /api/v1/project-changes-settings/:projectId/automatic-prime-contract}
 */
export function useProjectChangesSettingsControllerRemoveAutomaticPrimeContract(t0) {
  const $ = _c(19);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  let t2;
  if ($[2] !== options) {
    t2 = options ?? {};
    $[2] = options;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    mutation: t3,
    client: t4
  } = t2;
  let t5;
  if ($[4] !== t3) {
    t5 = t3 === undefined ? {} : t3;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const mutation = t5;
  let t6;
  if ($[6] !== t4) {
    t6 = t4 === undefined ? {} : t4;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const config = t6;
  let mutationOptions;
  let queryClient;
  if ($[8] !== mutation) {
    ({
      client: queryClient,
      ...mutationOptions
    } = mutation);
    $[8] = mutation;
    $[9] = mutationOptions;
    $[10] = queryClient;
  } else {
    mutationOptions = $[9];
    queryClient = $[10];
  }
  let t7;
  if ($[11] !== mutationOptions.mutationKey) {
    t7 = mutationOptions.mutationKey ?? projectChangesSettingsControllerRemoveAutomaticPrimeContractMutationKey();
    $[11] = mutationOptions.mutationKey;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const mutationKey = t7;
  let t8;
  if ($[13] !== config) {
    t8 = projectChangesSettingsControllerRemoveAutomaticPrimeContractMutationOptions(config);
    $[13] = config;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const baseOptions = t8 as UseMutationOptions<ProjectChangesSettingsControllerRemoveAutomaticPrimeContractMutationResponse, ResponseErrorConfig<ProjectChangesSettingsControllerRemoveAutomaticPrimeContract401 | ProjectChangesSettingsControllerRemoveAutomaticPrimeContract403 | ProjectChangesSettingsControllerRemoveAutomaticPrimeContract404>, {
    projectId: ProjectChangesSettingsControllerRemoveAutomaticPrimeContractPathParams["projectId"];
  }, TContext>;
  let t9;
  if ($[15] !== baseOptions || $[16] !== mutationKey || $[17] !== mutationOptions) {
    t9 = {
      ...baseOptions,
      mutationKey,
      ...mutationOptions
    };
    $[15] = baseOptions;
    $[16] = mutationKey;
    $[17] = mutationOptions;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return useMutation(t9, queryClient) as UseMutationResult<ProjectChangesSettingsControllerRemoveAutomaticPrimeContractMutationResponse, ResponseErrorConfig<ProjectChangesSettingsControllerRemoveAutomaticPrimeContract401 | ProjectChangesSettingsControllerRemoveAutomaticPrimeContract403 | ProjectChangesSettingsControllerRemoveAutomaticPrimeContract404>, {
    projectId: ProjectChangesSettingsControllerRemoveAutomaticPrimeContractPathParams["projectId"];
  }, TContext>;
}